import { render, staticRenderFns } from "./Bahn1RecapVideo.vue?vue&type=template&id=c24276f8&scoped=true&"
import script from "./Bahn1RecapVideo.vue?vue&type=script&lang=js&"
export * from "./Bahn1RecapVideo.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1RecapVideo.vue?vue&type=style&index=0&id=c24276f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24276f8",
  null
  
)

export default component.exports